import TagBox, { ITagBoxOptions } from "devextreme-react/tag-box";
import BaseControlProps from "interfaces/BaseControlProps";
import { GetNewId } from "shared/utility/CommonUtility";
import { useEffect, useState } from "react";
import { Validator, RequiredRule } from "devextreme-react/validator";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import { getSizeSpecificClasses, getControlRadius} from "shared/utility/ControlUtility";
import InputProps from "interfaces/InputProps";
import "./styles/Controls.css";

export default function PromineoMultiSelectDropdown(props: ITagBoxOptions & BaseControlProps & InputProps) {
  const { className, size, radiusSize, onValidated, controlRef, ...rest } = props;
  const { id, label, required, mode } = props;
  const [validatorRules, setValidatorRules] = useState<any>([]);

  useEffect(() => {
    const setValidationRules = () => {
      const rules = [];
      if (required) {
        const rule = (
          <RequiredRule
            key={`${GetNewId()}-${id}`}
            message={`${label} is required.`}
          />
        );
        rules.push(rule);
      }
      setValidatorRules(rules);
    };

    setValidationRules();
  }, [id, label, mode, required]);

  const getClassNames = () => {
    const defaultClassNames = `prom-select ${getSizeSpecificClasses(
      size
    )} ${getControlRadius(
      radiusSize
    )} border-1.5 border-primaryRed outline-none text-primaryRed`;
    return className ? `${defaultClassNames} ${className}` : defaultClassNames;
  };

  const DropdownButton = () => {
    return (
      <div className="icon dx-icon-chevrondown text-primaryRed mt-2"></div>
    );
  };

  return (
    <TagBox
      showSelectionControls={true}
      showDropDownButton={true}
      dropDownButtonRender={DropdownButton}
      className={getClassNames()}
      ref={controlRef}
      {...rest}
    >
      <Validator onValidated={onValidated}>{validatorRules}</Validator>
    </TagBox>
  );
}

PromineoMultiSelectDropdown.defaultProps = {
  size: ControlSize.Midium,
  radiusSize: ControlSize.Large,
};
